var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "container content-padding" }, [
      _c("p", { staticClass: "block_" }, [
        _vm._v("Data Protection Notice for Customers")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_" }, [_vm._v("BeNeat Company Limited")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("What is personal data?")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "Personal data is any information that relates to or identifies a living individual, both directly or indirectly. This also includes the collection of less explicit data that leads to an identification of a particular person."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("Collection of Personal Data")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("We may collect the following data from the users:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 Personal identification data including age, nationality, date of birth, etc."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 Contact information including address, phone number, e-mail address, etc."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("3 Payment data including bank account, payment method, etc.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 Transaction data including transaction number, purchase history, etc."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 On-site personal data including account name, password, personal interest regarding services, etc."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "6 Technical data including IP address number, log-in history, setting, web browser connection, etc."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "7 Marketing data including service satisfaction and feedback, etc."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [_vm._v("8 Image")]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "9 User location data in the background during traveling for providing services (only service providers using BeNeat Cleaner app)."
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Access to Personal Data")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "We access users personal data through 2 main following channels:"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 We access personal data directly from the users via the collection during the provision of service including:"
          )
        ])
      ]),
      _vm._v(" "),
      _c("ol", { staticClass: "list_" }, [
        _c("li", { staticClass: "block_4" }, [
          _c("span", { staticClass: "calibre2" }, [
            _vm._v(
              "User’s account registration, and the submission of application for any  services"
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "User’s subscription of any marketing and sales information including advertisement and promotion"
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("User’s consensual agreement when filling out the survey")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("User’s cookies when accessing the platform")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "Mutual contact between users and service providers both offline and online such as email enquiries and phone calls"
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("User’s purchase of any particular service or product")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "User’s log-in on both service provider’s platform and associated sites such as Facebook and Google"
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "User's location data in the background when service provider starts traveling from BeNeat Cleaner app. The data collection was performed every 15 minutes when the service provider starts traveling and stopped when the service providers confirmed checking-in customer accommodation."
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 We collect personal data of the users indirectly from the third-parties in the following cases: Facebook Login, Google Login, LINE Login, Email & Password Login"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("Data Collection Objectives")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "We may collect and use users personal data for any or all of the following purposes:"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 To perform obligations in the course of or in connection with our provision of the goods and/or services requested by the user"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 To process the payment of a particular service or product such as tours, attraction tickets, transportation service, etc."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 For post-sale customer service such as promotions and feedback enquiries"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("4 To verify user’s identity")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 For marketing research and customer relationship optimization"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "6 To comply with any applicable laws, regulations, codes of practice, guidelines, or rules, or to assist in law enforcement and investigations conducted by any governmental and/or regulatory authority"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "7 To transfer data to any unaffiliated third parties including our third party service providers and agents, relevant governmental and/or regulatory authorities, for the aforementioned purposes"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "8 To provide benefits for customer in case of user location data in the background. The customer could estimate the arrival time and distance of service provider as well as provide more traveling information if the service provider is getting lost."
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Sharing Personal Data")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "We may share and disclose your personal data to third parties in the following circumstances:"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 Within BeNeat Company Limited for the purpose outlined in this policy."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 To third-party service providers who require access to personal data in order to assist in the provision of the website, products and services, and other business-related functions such as website analytics providers or our third-party advertisement partners. These third-party service providers are limited to only accessing or using this data to provide services to us and must provide reasonable assurances they will appropriately safeguard the data."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("3 We may also disclose visits information to third-parties:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 Where required by law or regulatory requirement, court order or other judicial authorization"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 In response to lawful requested by public authorities including for the purposes of meeting national security and law enforcement requirements"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "6 In connection with the sale, transfer, merger, bankruptcy, restructuring or other reorganization of a business"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "7 To protect or defend our rights interests or property, or that of third parties"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "8 To investigate any wrongdoing in connection with the website or service"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("9 To protect the vital interests of an individual.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "10 We may also share Personal Information collected through the Website with third party companies so that they may offer products and services that we believe will be of interest to visitors, as well as third party advertising-serving companies to better target the adverts and other content displayed on website and to provide offers we think may be interests of visitors. The unsubscription of marketing is stated in the “Personal Data and Marketing Activities” section."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "11 We only share user location information in the background to the customer who owned the reservation and our operation team."
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Personal Data Processing")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "After the collection of users personal data, we may store the data regarding the following processes:"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v("1 Computer System including Amazon AWS, Digital Ocean")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 We may use the collected personal data with the purposes mentioned in “Data Collection Objectives”"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("3 We may disclose users personal data:")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre3" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "○ to staff members under BeNeat Company Limited, in order to perform obligations in the course of or in connection with our provision of the goods and services requested by users; or"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "○ to third party service providers, agents and other organisations we have engaged to perform any of the functions with reference to the above mentioned objectives and for safety purposes."
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("Data Storage and Data Retention")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("We may store users personal data using the following systems:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 Users personal data will be saved as soft copy data stored in our computer systems."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 Users personal data will be saved in service provider’s devices, such as computers, phones, and tablets. This includes the mentioned Computer System (Amazon AWS, Digital Ocean)."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 Data retention period will be illustrated in the “Data Retention” section below."
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Data Retention Period")]),
      _vm._v(" "),
      _c("table", { staticClass: "table_" }, [
        _c("tbody", { staticClass: "calibre4" }, [
          _c("tr", { staticClass: "calibre5" }, [
            _c("td", { staticClass: "td_" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("No.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_1" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("Type of Personal Data")
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_2" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("Retention Period")])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre5" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("1.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "Personal identification data including age, nationality, date of birth, etc."
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("10 years from contract termination date")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre5" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("2.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "Contact information including address, phone number, e-mail address, etc."
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("10 years from contract termination date")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre5" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("3.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "Payment data including bank account, payment method, etc."
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("10 years from contract termination date")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre5" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("4.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "Transaction data including transaction number, purchase history, etc."
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("10 years from contract termination date")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre5" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("5.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "On-site personal data including account name, password, personal interest regarding services, etc."
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("5 years from contract termination date")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre5" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("6.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "Technical data including IP address number, log-in history, setting, web browser connection, etc."
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("5 years from contract termination date")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre5" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("7.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "Marketing data including service satisfaction and feedback, etc."
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("5 years from contract termination date")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre5" }, [
            _c("td", { staticClass: "td_6" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("8.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_7" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("Image")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_8" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("5 years from contract termination date")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre5" }, [
            _c("td", { staticClass: "td_6" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("9.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_7" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("User location in the background")
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_8" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("5 years from contract termination date")
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Data Subject Rights")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Data subjects have the following rights:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 Right to withdraw consent: Users can withdraw their consent and request the processors to stop collecting their personal data."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 Right of Access: Users can submit data access requests, which oblige processors to provide a copy of any personal data they hold regarding data subjects. This includes a request for a disclosure of platforms and methods in which the processors collected the data from."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 Right of Rectification: Users can request an update on an inaccurate or incomplete personal data."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 Right to Erasure: Users can request that the service provider erase their data in certain circumstances, such as when the data is no longer necessary, the data was unlawfully processed or is no longer meeting the lawful ground for which it was collected. This includes the instance where the individual withdraws consent."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 Right to Restriction of Processing: Users can request the service provider to limit the way their personal data is used."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "6 Right to Data Portability: Users are permitted to obtain and reuse their personal data for their own purposes across different services. "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "7 Right to be informed: Users have the right to be notified about the collection of their personal data such as storage periods and purposes."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "8 Right to Object: Users can object to the processing of personal data that is collected on the grounds of legitimate interests or the performance of a task in the interest/exercise of official authority. "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "You may contact our Data Protection Officer if you have any enquiries or feedback on our personal data protection policies and procedures, or if you wish to make any request, in the following manner"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _c("span", { staticClass: "calibre2" }, [
          _vm._v(
            "If you wish to learn more about our terms and conditions, please visit { th: 'https://beneat.co/privacy', en: 'https://beneat.co/privacy' }. For full guidelines, please visit  Thailand Data Protection Guideline 2.0, Ministry of Digital Economy and Society website http://www.mdes.go.th, GDPR Guideline https://gdpr.eu/, European Commission https://ec.europa.eu/."
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "Note: There is no additional charge regarding the mentioned right entitlement, and users will be contacted within 30 days from the date of request "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("Personal Information Request Form")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "In the case that you would like to manage your personal data, including:"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v("1 Data access request")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("2 Data correction request")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("3 General Consent Withdrawal request")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("4 Complaint submission")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          'Please contact our Data Protection Officer through the following details in the "Contact Us" section down below.'
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("Personal Data and Marketing Activities")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "To optimize users satisfaction, we may distribute the information regarding our marketing activities such as promotion, discount, and news. This also includes information related to your preferences. Users can withdraw their consents after the subscription contacting Info@beneat.co."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("What are Cookies?")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "Cookies are text files stored on your computer's browser directory or program data subfolders. Cookies are created when you use your browser to visit a website that uses cookies to keep track of your movements within the site. If you wish to learn more about cookies, visit https://www.allaboutcookies.org/."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("How Do We Use Cookies?")]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 To increase the efficiency and safety in users log-in process"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 To collect user’s platform usage, content adjustments, and personal settings"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 To research an individual user’s behaviour on the platform for satisfaction optimization purposes"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 To research the behavioral trend of all users in order to increase the efficiency of the platform"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Types of Cookies")]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 Functionality Cookies: Functionality cookies record information about choices you have made in the platform such as personal settings, languages, and fonts. This allows us to tailor our platform to you."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 Advertising Cookies: Advertising cookies record your on-site behaviour and history of sites visited. This allows us to provide you the services, products, and advertisements that suit your preferences."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 Strictly Necessary Cookies: These cookies are essential for you to browse the website and use its features, such as accessing secure areas of the site. "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 Performance Cookies: These are cookies used for gathering site visitors data anonymously, including the page that is visited most frequently in the website. This allows us to efficiently improve our platform regarding users preferences."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 Third-party Cookies: These cookies will be determined by the third parties such as Google Analytics"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Cookies Setting")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "Users can disable cookies on their browsers, by following these steps:"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [_vm._v("For Safari Users:")]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v("1 Click the “Safari” menu, and tap “Preferences”.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 Click the “Privacy” tap and manage the following setting choices:"
          )
        ])
      ]),
      _vm._v(" "),
      _c("ol", { staticClass: "list_" }, [
        _c("li", { staticClass: "block_4" }, [
          _c("span", { staticClass: "calibre2" }, [
            _vm._v(
              "Enabling  “Prevent cross-site tracking” to block third-party cookies and prevent third-party websites from storing data on your computer. "
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "Enabling “Block all cookies” will prevent First-Party cookies, as well as Third-Party cookies. Enabling this may cause websites to work improperly, and Safari will warn you about this if you choose this option."
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "Choose the “Manage Website Data” button to remove certain website domains which have stored data on your computer."
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [_vm._v("For Google Chrome Users:")]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v("1 Open Chrome and tap on “Settings” at the top right.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("2 Click “Advanced” at the bottom.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("3 Under 'Privacy and security', click “Site Settings”.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 Click “Cookies”, then tap “ See all Cookies and Site Data”."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("5 If you wish to remove your cookies, tap “Remove All”.")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [
        _vm._v("For Internet Explorer Users:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 Open Internet Explorer and click “Tools” in the browser toolbar."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("2 Choose “Internet” Option.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("3 Click the “Privacy” tap.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 Under “Settings” move the slider to the top to block all cookies or to the bottom to allow all cookies, and then click OK."
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("Effect of Notice and Changes to Notice")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "This Notice applies in conjunction with any other notices, contractual clauses and consensual clauses that apply in relation to the collection, usage and disclosure of your personal data by us. Any links from other domains found on our site may be under a different personal data protection act."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "We may revise this notice from time to time without any prior notification. You may determine if any such revision has taken place by referring to the date on which this notice was last updated. Your continual use of our services constitutes your acknowledgement and acceptance of such changes."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [_vm._v("Effective date:")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [_vm._v("11/05/2020")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [_vm._v("Last updated:")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [_vm._v("11/05/2020")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Contact Us")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [_vm._v("Data Processor")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Name: BeNeat Company Limited")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Address: 119 M.9 T.Donkaew A.Maerim Chiang Mai, Thailand 50180")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Contact detail: 02 113 1138")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Email address: Info@beneat.co")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [_vm._v("Website: www.BeNeat.co")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [_vm._v("Data Protection Officer")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Name: Khomkhid Chatcharaphon")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Address: 297-299 Thanasarn Rd., Amphor Muang, Surin 32000")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Contact detail: 0865857584")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Email address: komkid.c@beneat.co")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "In the case that you find any of our staff members does not act in compliance with the aforementioned regulations, you can file a request or a complaint at the following organisation:"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [
        _vm._v(
          "Data Protection Committee, Ministry of Digital Economy and Society, Thailand"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "Address: The Government Complex Commemorating His Majesty the King's 80th BirthDay Anniversary 5th December, B.E.2550 (2007), Building B 6th - 7th Floor 120 Chaengwattana Road, Lak Si Intersection, Bangkok, 10210"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Phone number: +662 142 2233")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [
        _vm._v("Information Commissioner’s Office, United Kingdom")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Address: Wycliffe House, Water Lane, Wimslow, Cheshire SK9 5AF")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("Phone number: +44303 123 1113")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_6" }, [
        _vm._v("Data Protection Notice for Customers")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Personal Data Processing")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "The basis of our personal data processing is illustrated in (a) The Collection of Personal Data (b) Data Storage and Data Retention. The purposes of our data collection are as stated in (b) Data Collection Objectives. Our procedure are complied with the following standards:"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 Contract execution including payment confirmation emails after the purchase of services provided by the company, bank account transfer, or any other agreements that you have executed with the company."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 Data Subject's Consent: Regarding your agreement during our service registration, you can withdraw your consent by following these steps:"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre3" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "○ You can withdraw personal data disclosure consent, used in the mentioned objectives, at any circumstances. This includes the request of personal data removal and data anonymity change. To withdraw your consent, contact our data processors through following channels:"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("○ Electronic channel such as email and website")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("○ Verbal channel such as phone call or staff member")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("○ Written channel such as information letter ")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "Once our staff members have received your withdrawal submission, the request will be forwarded to our data processors. However, your consent withdrawal has no effect on the data processing of your previous consensual personal data."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("Exception of Personal Data Collection")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "The service providers are unable to collect your personal data without your consent, except for the following purposes:"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 To obtain data for public benefits such as scientific research and historical data."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 To assure critical benefits concerning the security of data subjects including physical health and safetiness."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 To act in compliance with the consensual agreement that the data subject is a contract party."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 To act in compliance with applicable laws, regulations, codes of practice, guidelines, or rules, or to assist in law enforcements and investigations conducted by any governmental or regulatory authority."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 For benefits legally obtained by service providers, data processors, and associated legal entities, except that the mentioned benefits are incompatible to basic data subjects right. "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("6 For public and legitimate interests of data processors.")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Access to Personal Data")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("We access your personal data via following processes:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v("1 When you log-in or register your account on our platform.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 When you submit registration forms, request forms, or any form associated with our service, both online and offline."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 When you make agreements or submit any information and file associated with our services."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 When you make contact with our service providers such as recorded phone calls, letters, faxes, face-to-face meetings, social media platforms, and emails."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 When you use our services on electronic platforms, including the use of cookies which will be adjusted once you have logged-in."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("6 When you process your transactions through our services.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("7 When you submit feedback or complaints.")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "8 When you register or make any consensual agreement during our marketing and advertising campaigns such as contests and discounts. This includes the activities launched with our partners and associated third parties."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "9 When you request certain services provided by our on-site outsource service providers such as transaction and logistics services."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "10 When you visit or log-in the websites or applications of our partners and associated third parties."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "11 When you install our application on your devices such as mobile phones, computers, or tablets."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "12 When you connect your account with third party’s websites or applications."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "13 When you submit your personal information to us for any reason."
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("Persona Data Storage and Retention")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "Further details are clarified in the Data Protection Notice for Customer’s “Data Storage and Data Retention” section."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Data Subject’s Right")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "Further details are clarified in the Data Protection Notice for Customer’s “Data Subject’s Right” section."
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2dc7ba4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2dc7ba4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/PrivacyEn.vue
// module id = 1506
// module chunks = 0